module.exports = __webpack_public_path__ + "static/media/user.871c32d0.svg";